const getLocaleMap = (locale: string) =>
  import(/* webpackChunkName: "[request]" */ `../i18n/translations/${locale}.json`).then((module) => module.default);

export const getLocaleTranslations = async (locale: string) => {
  return getLocaleMap(locale);
};
